import AddressSection from "./AddressSection";
import BankAccountSection, {
  BankAccountFormValues,
} from "./BankAccountSection";
import ReferencePeopleSection, { Organization } from "./ReferencePeopleSection";

export type ReferencePeopleSectionOrganization = Organization;
export type { BankAccountFormValues };
export { AddressSection, BankAccountSection, ReferencePeopleSection };
